"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveAnyPlants = void 0;
const Resources_1 = require("../Resources");
const OrOptions_1 = require("../inputs/OrOptions");
const SelectOption_1 = require("../inputs/SelectOption");
const DeferredAction_1 = require("./DeferredAction");
const CardName_1 = require("../CardName");
const MonsInsuranceBot_1 = require("../cards/automa/MonsInsuranceBot");
class RemoveAnyPlants {
    constructor(player, count = 1, title = 'Select player to remove up to ' + count + ' plants') {
        this.player = player;
        this.count = count;
        this.title = title;
        this.priority = DeferredAction_1.Priority.ATTACK_OPPONENT;
    }
    execute() {
        var _a;
        if (this.player.game.isSoloMode()) {
            this.player.game.someoneHasRemovedOtherPlayersPlants = true;
            if (this.player.isCorporation(CardName_1.CardName.BENTENMARU)) {
                this.player.addResource(Resources_1.Resources.PLANTS, this.count, { log: true });
            }
            if (((_a = this.player.game.automaBotCorporation) === null || _a === void 0 ? void 0 : _a.name) === CardName_1.CardName.MONS_INSURANCE_BOT) {
                MonsInsuranceBot_1.MonsInsuranceBot.resolveMonsInsuranceBot(this.player);
            }
            return undefined;
        }
        const candidates = this.player.game.getPlayers().filter((p) => p.id !== this.player.id && !p.plantsAreProtected() && p.plants > 0);
        if (candidates.length === 0) {
            return undefined;
        }
        const removalOptions = candidates.map((candidate) => {
            const qtyToRemove = Math.min(candidate.plants, this.count);
            return new SelectOption_1.SelectOption('Remove ' + qtyToRemove + ' plants from ' + candidate.name, 'Remove plants', () => {
                candidate.deductResource(Resources_1.Resources.PLANTS, qtyToRemove, { log: true, from: this.player });
                return undefined;
            });
        });
        const orOptions = new OrOptions_1.OrOptions(...removalOptions, new SelectOption_1.SelectOption('Skip removing plants', 'Confirm', () => {
            return undefined;
        }));
        orOptions.title = this.title;
        return orOptions;
    }
}
exports.RemoveAnyPlants = RemoveAnyPlants;
//# sourceMappingURL=RemoveAnyPlants.js.map